import { Cloud, Cctv, KeyRound, Monitor } from "lucide-react";
import { APDisc, C, Draw, Icon, Label, Packet, Pop, Svg, Unit, useCycle } from "./shared";

const LINES = [
  "Your internet line plugs into the Dream Machine Pro — the brain of the network.",
  "The switch powers and connects every device down a single cable.",
  "Staff, guests and cameras each get their own network, so a guest can never see your files.",
  "Everything is managed from one UniFi dashboard.",
];

const KIDS = [
  { x: 90, label: "U7 PRO", sub: "VLAN 10", color: C.cyan, kind: "ap" },
  { x: 200, label: "U7 PRO", sub: "VLAN 20 GUEST", color: C.amber, kind: "ap" },
  { x: 310, label: "G5 TURRET", sub: "VLAN 30 IOT", color: C.green, icon: Cctv },
  { x: 420, label: "G2 PRO", sub: "VLAN 30 IOT", color: C.green, icon: KeyRound },
  { x: 520, label: "DESKS", sub: "VLAN 10", color: C.cyan, icon: Monitor },
];
const down = (x) => `M300,196 V245 H${x} V282`;

export const DesignAnim = ({ say }) => {
  useCycle(say, LINES);
  return (
  <Svg>
    <Pop delay={0.1}>
      <circle cx="300" cy="38" r="20" fill={C.body} stroke={C.line} />
      <Icon as={Cloud} x={300} y={38} color={C.cyan} />
    </Pop>
    <Label x={338} y={42} anchor="start">INTERNET · FIBRE</Label>
    <Draw d="M300,58 V104" delay={0.3} color={C.cyan} />
    <Packet d="M300,58 V104" dur={1.2} />
    <Pop delay={0.5}><Unit x={215} y={104} w={170} h={22} ports={8} /></Pop>
    <Label x={395} y={119} anchor="start" color={C.text}>DREAM MACHINE PRO</Label>
    <Draw d="M300,126 V172" delay={0.8} color={C.cyan} />
    <Packet d="M300,126 V172" dur={1.2} begin={0.4} />
    <Pop delay={1}><Unit x={190} y={172} w={220} h={24} ports={16} screen={false} /></Pop>
    <Label x={420} y={188} anchor="start" color={C.text}>USW PRO MAX 24 POE</Label>
    {KIDS.map((k, i) => (
      <g key={i}>
        <Draw d={down(k.x)} delay={1.3 + i * 0.12} color={k.color} w={1.2} />
        <Packet d={down(k.x)} dur={1.8} begin={i * 0.3} color={k.color} />
        <Pop delay={1.6 + i * 0.12}>
          {k.kind === "ap" ? <APDisc x={k.x} y={300} r={16} /> : (
            <g>
              <circle cx={k.x} cy="300" r="17" fill={C.body} stroke={k.color} strokeOpacity="0.7" />
              <Icon as={k.icon} x={k.x} y={300} s={16} color={k.color} />
            </g>
          )}
          <Label x={k.x} y={334} color={C.text}>{k.label}</Label>
          <Label x={k.x} y={347} color={k.color} size={8}>{k.sub}</Label>
        </Pop>
      </g>
    ))}
    <Label x={20} y={384} anchor="start">TOPOLOGY · 3 VLANS · 1 CONSOLE</Label>
  </Svg>
  );
};
